
<template>
    <img src="../../assets/images/loading.gif" alt="Loading image" width="40px">
</template>
